import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Dashboard from './Dashboard';
import UsersBalanceSummaryTable from './UsersBalanceSummaryTable';

const DashboardVersionSwitch = () => {
    const [dashboardVersion, setDashboardVersion] = useState('v2');
    const params = useParams();

    useEffect(() => {
        // Get dashboard version from localStorage on component mount
        const savedVersion = localStorage.getItem('dashboardVersion');
        if (savedVersion) {
            setDashboardVersion(savedVersion);
        } else {
            // Default to v2 if no preference is stored
            setDashboardVersion('v2');
            localStorage.setItem('dashboardVersion', 'v2');
        }
    }, []);

    // Listen for localStorage changes (when user switches in AccountPopover)
    useEffect(() => {
        const handleStorageChange = () => {
            const newVersion = localStorage.getItem('dashboardVersion');
            if (newVersion) {
                setDashboardVersion(newVersion);
            }
        };

        // Listen for storage events (for changes from other tabs)
        window.addEventListener('storage', handleStorageChange);

        // Also listen for custom events (for changes within the same tab)
        window.addEventListener('dashboardVersionChanged', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('dashboardVersionChanged', handleStorageChange);
        };
    }, []);    // Render the appropriate dashboard component based on version
    if (dashboardVersion === 'v1') {
        return <UsersBalanceSummaryTable />;
    }

    return <Dashboard />;
};

export default DashboardVersionSwitch;
